import { Check, Clock, Users2, Briefcase } from "lucide-react";

const COURSE_IMG =
    "https://images.pexels.com/photos/15831830/pexels-photo-15831830.jpeg";

const COURSE_BG =
    "https://images.unsplash.com/photo-1582719471384-894fbb16e074?auto=format&fit=crop&w=1600&q=70";

const CAREERS = [
    "Pharmacy Technician",
    "Hospital Pharmacist",
    "Community Pharmacist",
    "Sales & Marketing",
    "Quality Control / QA",
    "Pharmaceutical Production",
    "Clinical Research Associate",
    "Regulatory Affairs Specialist",
    "Drug Inspector",
    "Pharmacy Educator",
];

export const Course = () => (
    <section id="course" data-testid="course-section" className="section-bg relative py-24 lg:py-32 bg-white">
        <div
            className="section-bg__media"
            style={{ backgroundImage: `url('${COURSE_BG}')` }}
            aria-hidden="true"
        />
        <div className="section-bg__veil veil-course" aria-hidden="true" />
        <div className="blob blob--gold" style={{ width: 360, height: 360, top: -100, right: -120 }} aria-hidden="true" />
        <div className="blob blob--green" style={{ width: 300, height: 300, bottom: -120, left: -120, animationDelay: "4s" }} aria-hidden="true" />

        <div className="max-w-7xl mx-auto px-5 md:px-8 lg:px-12 relative">
            <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-center">
                <div className="lg:col-span-6 reveal">
                    <div className="zoom-wrap rounded-3xl shadow-lg">
                        <img
                            src={COURSE_IMG}
                            alt="Pharmacy practice"
                            className="w-full h-[480px] lg:h-[600px] object-cover rounded-3xl"
                        />
                    </div>
                </div>

                <div className="lg:col-span-6 reveal delay-2">
                    <span className="section-rule eyebrow">Flagship Course</span>
                    <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl mt-5 leading-[1.05] text-stone-900">
                        Diploma in Pharmacy
                        <span className="block italic text-[var(--brand-green)]">D. Pharm — 2 Years.</span>
                    </h2>
                    <p className="mt-6 text-stone-600 text-base md:text-lg leading-relaxed max-w-xl">
                        A two-year diploma programme that prepares you to work as a skilled pharmacy
                        technician — covering drug formulation, dispensing, pharmacology and
                        pharmacy practice across hospital, retail and industry settings.
                    </p>

                    <div className="mt-8 grid grid-cols-3 gap-3 max-w-md">
                        <div className="tactile-card p-4">
                            <Clock size={18} className="text-[var(--brand-green)]" />
                            <div className="font-display text-2xl mt-2 text-stone-900">2 yrs</div>
                            <div className="text-[11px] uppercase tracking-[0.16em] text-stone-500">Duration</div>
                        </div>
                        <div className="tactile-card p-4">
                            <Users2 size={18} className="text-[var(--brand-blue)]" />
                            <div className="font-display text-2xl mt-2 text-stone-900">60</div>
                            <div className="text-[11px] uppercase tracking-[0.16em] text-stone-500">Seats</div>
                        </div>
                        <div className="tactile-card p-4">
                            <Briefcase size={18} className="text-[var(--brand-green)]" />
                            <div className="font-display text-2xl mt-2 text-stone-900">10+</div>
                            <div className="text-[11px] uppercase tracking-[0.16em] text-stone-500">Roles</div>
                        </div>
                    </div>

                    <div className="mt-10">
                        <h3 className="font-display text-xl text-stone-900 mb-4">Career Pathways</h3>
                        <div className="flex flex-wrap gap-2">
                            {CAREERS.map((c) => (
                                <span
                                    key={c}
                                    data-testid={`career-pill-${c.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                                    className="inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full bg-stone-50 border border-stone-200 text-xs md:text-sm text-stone-700 hover:bg-[var(--brand-green)] hover:text-white hover:border-[var(--brand-green)] transition-colors cursor-default"
                                >
                                    <Check size={12} />
                                    {c}
                                </span>
                            ))}
                        </div>
                    </div>

                    <div className="mt-10 flex flex-wrap gap-3">
                        <a href="#admission" data-testid="course-apply-cta" className="btn-primary">
                            Apply for D.Pharm
                            <i className="fa-solid fa-arrow-right text-xs" />
                        </a>
                        <a href="#contact" data-testid="course-enquiry-cta" className="btn-outline">
                            Talk to Admissions
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </section>
);

export default Course;
